/**
 * Các hàm tiện ích để làm việc với URL slugs
 */

/**
 * Chuyển đổi một chuỗi thành slug URL
 * - Chuyển sang chữ thường
 * - Loại bỏ dấu tiếng Việt
 * - Thay thế khoảng trắng và ký tự đặc biệt bằng dấu gạch ngang
 * - Loại bỏ các dấu gạch ngang liên tiếp
 * - Cắt bỏ gạch ngang ở đầu và cuối
 */
export const createSlug = (text) => {
  if (!text) return "";

  // Chuyển text sang chữ thường
  let slug = text.toLowerCase();

  // Loại bỏ dấu tiếng Việt
  slug = slug
    .replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, "a")
    .replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, "e")
    .replace(/i|í|ì|ỉ|ĩ|ị/gi, "i")
    .replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, "o")
    .replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, "u")
    .replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, "y")
    .replace(/đ/gi, "d");

  // Thay thế ký tự đặc biệt và khoảng trắng bằng dấu gạch ngang
  slug = slug
    .replace(/[^a-z0-9 -]/g, "") // Loại bỏ các ký tự đặc biệt
    .replace(/\s+/g, "-") // Thay thế khoảng trắng bằng dấu gạch ngang
    .replace(/-+/g, "-") // Loại bỏ các dấu gạch ngang liên tiếp
    .replace(/^-+/, "") // Cắt bỏ gạch ngang ở đầu
    .replace(/-+$/, ""); // Cắt bỏ gạch ngang ở cuối

  return slug;
};

/**
 * Tìm bài viết dựa vào slug
 */
export const findArticleBySlug = (articles, slug) => {
  if (!articles || !slug) return null;

  return articles.find((article) => createSlug(article.title) === slug);
};
